// Core
import React from 'react';

// Component
import { Dot } from './StatusDot.style';
import { StatusDotProps, StatusDotStatus } from './StatusDot.types';

function StatusDot({
  className,
  status = StatusDotStatus.offline,
  testId,
}: StatusDotProps): JSX.Element {
  return (
    <Dot
      data-testid={testId}
      className={className}
      status={status}
    />
  );
}

export { StatusDot };
